import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// import CustomCancelSubmit from "../CustomCancelSubmit";
import "./Index.css";
import CustomButton from "../../Atoms/CustomButton";

const ConfirmModal = ({
  handleSubmit,
  handleClose,
  message,
  subMessage,
  button_label = "DELETE",
  loading = false,
  icon_type = "DELETE",
}) => {
  return (
    <>
      <div className="data-import-index-delete-modal-con">
        <div className="data-import-index-delete-icon-con">
          <ErrorOutlineIcon sx={{ fontSize: "40px", color: "#f24646" }} />
        </div>
        <p className="data-import-index-delete-para1">{message}</p>
        <p className="data-import-index-delete-para2">{subMessage}</p>
      </div>
      <div className="btnActnBar">
        <CustomButton
          action={icon_type}
          label={loading ? "Loading..." : button_label}
          btnType="danger"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};

export default ConfirmModal;
